import { io } from 'socket.io-client';
import { SOCKET_URL } from '../../Config/axiosConfig';
export const socket = io(SOCKET_URL, {
  transports: ['websocket'],
  maxHttpBufferSize: 1e7,
  reconnection: true,
  autoConnect: false,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000
});
